export default __webpack_public_path__ + "static/media/KOD0157-min.64c04524.webp";